import { apiClient } from './apiClient';

export type SalesforceBackedPreviewRequest = {
  accountId: string;
  introductionId: string;
  userId?: string;
  metadata?: Record<string, unknown>;
};

export type DirectPayloadPreviewRequest = {
  data: Record<string, unknown>;
  metadata?: Record<string, unknown>;
};

export type CreateGenerationRequest = {
  accountId: string;
  introductionId: string;
  userId?: string;
  regenerateFromVersion?: number;
};

export type CreateGenerationResponse = {
  requestId: string;
  status: 'pending';
};

export type GetGenerationStatusResponse = {
  requestId: string;
  status: 'pending' | 'processing' | 'success' | 'failed';
  versionId?: string;
  error?: string;
};

const API_V1 = '/api/v1';

export const generationsService = {
  preview(
    body: SalesforceBackedPreviewRequest | DirectPayloadPreviewRequest,
    args?: { token?: string; signal?: AbortSignal }
  ) {
    return apiClient.postJson<string>(`${API_V1}/generations/preview`, body, {
      headers: {
        'x-user-token': args?.token,
      },
      signal: args?.signal,
    });
  },

  create(body: CreateGenerationRequest, args?: { token?: string; signal?: AbortSignal }) {
    return apiClient.postJson<CreateGenerationResponse>(`${API_V1}/generations`, body, {
      headers: {
        'x-user-token': args?.token,
      },
      signal: args?.signal,
    });
  },

  getStatus(requestId: string, args?: { token?: string; signal?: AbortSignal }) {
    return apiClient.getJson<GetGenerationStatusResponse>(`${API_V1}/generations/${requestId}`, {
      headers: {
        'x-user-token': args?.token,
      },
      signal: args?.signal,
    });
  },
};
